import {GetStaticProps} from "next";
import {MarkdownMetaDataInterface} from "../interfaces/MarkdownMetaDataInterface";
import SimpleMarkdownPageWithHeader from "../components/common/SimpleMarkdownPageWithHeader";
import {getStaticPropsForMarkdownPage} from "../helpers/GetStaticPropsForMarkdownPage";
import {getSafeLocale} from "../helpers/LocalizeObject";
import Layout from "../components/common/Layout";
import {ReactElement} from "react";

function Page({
	              result,
	              markdown: MDXFile,
              }: {
	result: MarkdownMetaDataInterface;
	markdown: any;
}) {

	return (<>
			<SimpleMarkdownPageWithHeader mdxFile={MDXFile} metadata={result}/>
		</>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	return getStaticPropsForMarkdownPage(getSafeLocale(context.locale), "agb");
};

Page.getLayout = function getLayout(page: ReactElement) {
	return (
		<Layout 
			headerNotTransparent={false}
			hasShadow={true}
		>
			{page}
		</Layout>
	);
};

export default Page;
